module.exports = __webpack_public_path__ + "img/weather.17fb3f53.svg";